<label *ngIf="leftLabel">{{ label }}</label>
<div #dropdownContainer class="input-field" [class.invalid]="hasError"
     (click)="preventPropagation($event)">
    <label *ngIf="topLabel" for="float-input" class="active">{{ label }}</label>
    <p-multiSelect [options]="items"
                   [showHeader]="hasHeader"
                   [(ngModel)]="selectedItems"
                   (onChange)="onItemSelect($event)"
                   [defaultLabel]="label"
                   [placeholder]="placeholder"
                   optionLabel="name"
                   display="chip"></p-multiSelect>
    <label *ngIf="floatLabel" for="float-input" class="active">{{ label }}</label>
    <app-form-error-list *ngIf="showErrors"
                         [errorMap]="formControl.errors">
    </app-form-error-list>
</div>